<template>
    <div class="qr-code-wrapper">
        <img src="/img/bg/qrcode.png" class="qrcode">
        <div class="qr-tips">
            <div class="iconfont iconicon_scan"></div>
            <div>
                <div>打开***APP</div>
                <div class="c3">该功能暂未开放</div>
            </div>
        </div>
        <div class="login-menu">
            <a href="#">下载APP</a>
            <a href="#">免费注册</a>
        </div>

    </div>
</template>
<script>
export default {
    name: "codelogin",
    data() {
        return {}
    }
};

</script>
<style lang="scss">
.qr-code-wrapper {
    padding-bottom:20px;
    text-align: center;

    .qrcode {
        display: block;
        width: 120px;
        height: 120px;
        margin: 0 auto;

    }

    .qr-tips {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 15px;
        color: #999;
        font-size: 12px;
        .iconfont {
            margin-right: 5px;
            font-size: 28px;
            color: #1890FF;
        }
        .c3{
            color: #333;
        }
    }
}

</style>
